import { render, staticRenderFns } from "./AverageTable.vue?vue&type=template&id=ab6a8494&"
import script from "./AverageTable.vue?vue&type=script&lang=js&"
export * from "./AverageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports